// extracted by mini-css-extract-plugin
export default {"confirmed-datetime":"ServicesBookingFeedback_confirmed-datetime__J3Ff7"};